const DEFAULT_PRIMARY = "#f7c935";
const DEFAULT_BG = "#0b0811";

const hex = (c) => {
  const m = /^#?([0-9a-f]{6})$/i.exec((c || "").trim());
  return m ? `#${m[1].toLowerCase()}` : null;
};
const rgb = (h) => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
const toHex = ([r, g, b]) => "#" + [r, g, b].map(v => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, "0")).join("");
const luminance = (h) => { const [r, g, b] = rgb(h).map(v => v / 255); return 0.2126 * r + 0.7152 * g + 0.0722 * b; };
const mix = (h, target, ratio) => toHex(rgb(h).map((v, i) => v + (target[i] - v) * ratio));
export const lighten = (h, r) => mix(h, [255, 255, 255], r);
export const darken = (h, r) => mix(h, [0, 0, 0], r);
export const onColor = (h) => (luminance(h) > 0.45 ? "#14101c" : "#ffffff");

// Habillage résolu d'une société (branding du Builder + repli sur logo/couleur de la fiche)
export function resolveBrand(societe) {
  const b = societe?.builder?.branding || {};
  const primary = hex(b.primary) || hex(societe?.color) || DEFAULT_PRIMARY;
  const background = hex(b.background) || DEFAULT_BG;
  return {
    name: b.app_name || societe?.name || "",
    logo: b.logo_url || societe?.logo || "",
    logoLight: b.logo_light_url || "",
    cover: b.cover_url || "",
    primary,
    secondary: hex(b.secondary) || "#1f2937",
    accent: hex(b.accent) || primary,
    background,
    theme: b.login_theme === "light" ? "light" : "dark",
    title: b.login_title || b.welcome_title || "",
    tagline: b.login_tagline || "",
    legal: b.legal_mentions || "",
    footer: b.footer_text || "",
    font: b.font_family || "",
    isCustom: primary !== DEFAULT_PRIMARY || background !== DEFAULT_BG,
  };
}

export function themeVars(brand) {
  const panelBg = luminance(brand.background) > 0.5 ? DEFAULT_BG : brand.background;
  return {
    "--brand-primary": brand.primary,
    "--brand-primary-dark": darken(brand.primary, 0.12),
    "--brand-on-primary": onColor(brand.primary),
    "--brand-bg": panelBg,
    "--brand-surface": lighten(panelBg, 0.05),
    "--brand-surface-2": lighten(panelBg, 0.08),
    "--brand-surface-3": lighten(panelBg, 0.11),
  };
}

export function applyPanelTheme(societe) {
  const root = document.documentElement;
  // Le panel ne change de thème que si le Builder définit explicitement une couleur (la couleur de la fiche n'est qu'une étiquette)
  const explicit = societe?.builder?.branding && (hex(societe.builder.branding.primary) || hex(societe.builder.branding.background));
  const brand = societe && explicit ? resolveBrand(societe) : null;
  if (!brand || !brand.isCustom) {
    root.removeAttribute("data-brand");
    ["--brand-primary", "--brand-primary-dark", "--brand-on-primary", "--brand-bg", "--brand-surface", "--brand-surface-2", "--brand-surface-3"].forEach(v => root.style.removeProperty(v));
    return null;
  }
  Object.entries(themeVars(brand)).forEach(([k, v]) => root.style.setProperty(k, v));
  root.setAttribute("data-brand", societe.slug || societe.societe_id);
  return brand;
}
